import { PUT_SETTING } from '../constants';
import { putSpAuthSalonSettings } from '../../services/api';

const spAuthSalonSettings = params => ({
  type: PUT_SETTING,
  payload: putSpAuthSalonSettings(params),
});

export default spAuthSalonSettings;



// WEBPACK FOOTER //
// ./src/redux/actions/putSalonSettings.js